<template>
  <div>
    <div class="basic-info">
      <div class="basic-title">
        <span>{{ policyDetail.insuranceName }}</span>
      </div>
      <div class="basic_content">
        <div class="basic_content_left">
          <div class="basic-text" v-if="policyDetail.insuranceNo">
            保单号：{{ policyDetail.insuranceNo }}
          </div>
          <div class="basic-text">订单号：{{ policyDetail.selfPolicySn }}</div>
          <div class="basic-text">
            支付状态：{{ policyDetail.payStatus | filterPay }}
          </div>
        </div>
        <div class="basic_content_right" @click="quickInsure(policyDetail)" v-show="showQuick(policyDetail)">
          延续保障
        </div>
      </div>
    </div>
    <div class="type-menu">
      <div class="type-item" :class="{ active: type === 'basic' }">
        <div @click="switchType('basic')">
          <span>订单明细</span>
        </div>
        <img class="arc-img" src="../../assets/img/common/down_arc.png" />
      </div>
      <div class="type-item" :class="{ active: type === 'appnt' }">
        <div @click="switchType('appnt')">
          <span>购买人</span>
        </div>
        <img class="arc-img" src="../../assets/img/common/down_arc.png" />
      </div>
      <div class="type-item" :class="{ active: type === 'insured' }">
        <div @click="switchType('insured')">
          <span>参保人</span>
        </div>
        <img class="arc-img" src="../../assets/img/common/down_arc.png" />
      </div>
      <div class="type-item" :class="{ active: type === 'benefit' }">
        <div @click="switchType('benefit')">
          <span>受益人</span>
        </div>
        <img class="arc-img" src="../../assets/img/common/down_arc.png" />
      </div>
    </div>
    <div class="policy-info" v-if="type === 'basic'">
      <div class="table-wrap">
        <table>
          <tbody>
            <tr>
              <td class="td-tag">产品名称</td>
              <td class="td-text">{{ policyDetail.insuranceName }}</td>
            </tr>
            <tr>
              <td class="td-tag">份数</td>
              <td class="td-text">{{ policyDetail.numbers }}</td>
            </tr>
            <tr>
              <td class="td-tag">交费年限</td>
              <td class="td-text">
                {{
                  policyDetail.payFrequencyNumber
                }}{{ policyDetail | unitText }}
              </td>
            </tr>
            <tr v-if="!policyDetail.leChengTeYaoProd">
              <td class="td-tag">
                保单号
              </td>
              <td class="td-text">{{ policyDetail.insuranceNo }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="policyDetail.insuranceProductCode !== 'HN22001'">
          <div class="table-title">
            住院及特殊病种门诊医疗保险金（非罕见病治疗）:
          </div>
          <table style="padding-bottom:10px;">
            <tbody>
              <tr>
                <td class="td-tag">基本医保内</td>
                <td class="td-text">
                  150万
                </td>
              </tr>
              <tr>
                <td class="td-tag">基本医保外</td>
                <td class="td-text">
                  100万
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-title">
            住院及特殊病种门诊医疗保险金（罕见病治疗）:
          </div>
          <table style="padding-bottom:10px;">
            <tbody>
              <tr>
                <td class="td-tag">基本医保内</td>
                <td class="td-text">
                  50万
                </td>
              </tr>
              <tr>
                <td class="td-tag">基本医保外</td>
                <td class="td-text">
                  50万
                </td>
              </tr>
              <tr>
                <td class="td-tag">特定药品费用医疗保险金</td>
                <td class="td-text">
                  50万
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <div class="table-title">
            住院及特殊病种门诊医疗保险金：
          </div>
          <table style="padding-bottom:10px;">
            <tbody>
              <tr>
                <td class="td-tag">基本医保内</td>
                <td class="td-text">
                  150万
                </td>
              </tr>
              <tr>
                <td class="td-tag">基本医保外</td>
                <td class="td-text">
                  100万
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-title">
            特定药械费用医疗保险金：
          </div>
          <table style="padding-bottom:10px;">
            <tbody>
              <tr>
                <td class="td-tag">特定药械、CAR-T药品费用保险金</td>
                <td class="td-text">
                  50万
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="policy-info" v-if="type === 'appnt'">
      <div class="table-wrap">
        <table>
          <tbody>
            <tr>
              <td class="td-tag">姓名</td>
              <td class="td-text">{{ appntInsuredInfo.appnt.userName }}</td>
            </tr>
            <tr>
              <td class="td-tag">证件类型</td>
              <td class="td-text">
                {{ appntInsuredInfo.appnt.userCardType | filterCardType }}
              </td>
            </tr>
            <tr>
              <td class="td-tag">证件号码</td>
              <td class="td-text">{{ appntInsuredInfo.appnt.userCardNo }}</td>
            </tr>
            <tr v-if="appntInsuredInfo.appnt.userCardType === 'identityCard'">
              <td class="td-tag">生日</td>
              <td class="td-text">
                {{ appntInsuredInfo.appnt.userBirthday | filterBirthday }}
              </td>
            </tr>
            <tr v-if="appntInsuredInfo.appnt.userCardType === 'identityCard'">
              <td class="td-tag">性别</td>
              <td class="td-text">
                {{ appntInsuredInfo.appnt.userSex | filterGender }}
              </td>
            </tr>
            <tr v-if="appntInsuredInfo.appnt.userCardType === 'identityCard'">
              <td class="td-tag">手机号</td>
              <td class="td-text">{{ appntInsuredInfo.appnt.userMobile }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="policy-info" v-if="type === 'insured'">
      <div class="table-wrap" v-for="(v, i) in appntInsuredInfo.insured" :key="i">
        <table>
          <tbody>
            <tr>
              <td class="td-tag" style="font-weight: bold">
                参保人{{ i + 1 }}
              </td>
            </tr>
            <tr>
              <td class="td-tag">姓名</td>
              <td class="td-text">{{ v.userName }}</td>
            </tr>
            <tr>
              <td class="td-tag">证件类型</td>
              <td class="td-text">{{ v.userCardType | filterCardType }}</td>
            </tr>
            <tr>
              <td class="td-tag">证件号码</td>
              <td class="td-text">{{ v.userCardNo }}</td>
            </tr>
            <tr>
              <td class="td-tag">生日</td>
              <td class="td-text">{{ v.userBirthday | filterBirthday }}</td>
            </tr>
            <tr>
              <td class="td-tag">性别</td>
              <td class="td-text">{{ v.userSex | filterGender }}</td>
            </tr>
            <tr>
              <td class="td-tag">与购买人关系</td>
              <td class="td-text">{{ v.insuredRelation | filterrelation }}</td>
            </tr>
            <!-- <tr v-if="!policyDetail.leChengTeYaoProd">
              <td class="td-tag">
                手机号
              </td>
              <td class="td-text">{{ v.userMobile }}</td>
            </tr> -->
            <tr>
              <td class="td-tag">保单号</td>
              <td class="td-text">{{ v.insuranceNo }}</td>
            </tr>
            <tr>
              <td class="td-tag">保险期间</td>
              <td class="td-text">
                {{ v.startDate | shortDate }} 至
                {{ v.endDate | shortDate }}
              </td>
            </tr>
            <tr>
              <td class="td-tag">保单状态</td>
              <td class="td-text">{{ v.insuranceStatus | filterStatus }}</td>
            </tr>
          </tbody>
        </table>
        <div class="btn-group" v-if="policyDetail.payType == 'selfAcc'">
          <div v-if="
            policyDetail.payStatus === 'payYet' &&
            policyDetail.reserveData3 !== 'zjtd' &&
            policyDetail.fromSourceCode !== 'yxhb00000317' &&
            (policyDetail.insuranceStatus === 'examine_pass' ||
              policyDetail.insuranceStatus === 'effective' ||
              policyDetail.insuranceStatus === 'partEffective') &&
            i == appntInsuredInfo.insured.length - 1
          " id="Personal_Center_Chargeback" class="btn-div" @click="refundBtn(v)">
            <span v-if="
              v.insuranceStatus !== 'effective' &&
              policyDetail.insuranceStatus === 'examine_pass'
            ">退单</span>
            <span v-else>退保</span>
          </div>
          <div class="btn-div" v-if="v.insuranceStatus === 'effective' || v.insuranceStatus === 'unEffective'"
            id="Obtain_InsurancePolicy" @click="getPersonPolicyPdf(v)">
            获取电子保单
          </div>
        </div>
        <div class="btn-group" v-else>
          <div v-if="
            v.payStatus === 'payYet' &&
            v.payType !== 'selfAcc' &&
            policyDetail.fromSourceCode !== 'yxhb00000317' &&
            policyDetail.reserveData3 !== 'zjtd' &&
            (v.insuranceStatus === 'examine_pass' ||
              v.insuranceStatus === 'effective')
          " id="Personal_Center_Chargeback" class="btn-div" @click="refundBtn(v)">
            <span v-if="v.insuranceStatus !== 'effective'">退单</span>
            <span v-else>退保</span>
          </div>
          <div class="btn-div" v-if="v.insuranceStatus === 'effective' || v.insuranceStatus === 'unEffective'"
            id="Obtain_InsurancePolicy" @click="getPersonPolicyPdf(v)">
            获取电子保单
          </div>
        </div>
        <!-- <div class="btn-group">
         
        </div> -->
        <div class="btn-div" v-if="
          (v.payStatus === 'payYet' ||
            policyDetail.payStatus === 'waitPay') &&
          !v.userCardNo
        " @click="goChange(i)">
          补全证件号
        </div>
      </div>

      <div class="btns">
        <div class="btn-div" id="Personal_Center_To_Pay" v-if="policyDetail.isNeedPay" @click="goPay">
          去支付
        </div>
        <div class="btn-div" id="Personal_Center_Cancel_Order" v-if="
          policyDetail.payStatus === 'waitPay' &&
          policyDetail.insuranceStatus === 'examine_pass'
        " @click="closeUserInsured">
          取消订单
        </div>
        <!-- <div
          class="btn-div"
          id="Obtain_InsurancePolicy"
          v-if="policyDetail.insuranceStatus === 'effective'"
          @click="getPolicyPdf"
        >
          获取电子保单
        </div> -->
      </div>
    </div>
    <div class="policy-info" v-if="type === 'benefit'">
      <div class="table-wrap">
        <table>
          <tbody>
            <tr>
              <td class="td-tag">受益人</td>
              <td class="td-text">法定</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- <main-menu />  退款 -->
    <van-overlay :show="refundFlag" @click="refundFlag = false">
      <div class="refund-comtent" @click.stop>
        <div class="refund-title">请验证购买人手机号</div>
        <van-field v-model.trim="appntMobileNumber" name="appntMobileNumber" label="手机号" placeholder="手机号" type="number"
          @blur="checkPhone" :error-message="errMsg.mobilePhone" clearable
          :rules="[{ required: true, message: '请填写手机号' }]" />
        <van-field v-model.trim="captcha" name="captcha" label="验证码" placeholder="验证码" type="number" maxlength="6"
          clearable @blur="checkVeriCode" :error-message="errMsg.captcha"
          :rules="[{ required: true, message: '请填写验证码' }]">
          <van-button slot="button" class="code-btn" size="small" :class="{ 'disable-btn': isDisable }" type="info"
            @click.prevent="sendVeriCode">
            {{ captchaText }}
          </van-button>
        </van-field>
        <div class="refund-btn-group" style="margin: 16px">
          <van-button size="small" type="default" class="cancel-btn" round @click="refundFlag = false">
            取消
          </van-button>
          <van-button size="small" class="submit-btn" round @click="OrderRefund">
            提交
          </van-button>
        </div>
      </div>
    </van-overlay>

    <van-dialog v-model="show" title="补全信息" :showConfirmButton="false">
      <van-form ref="buyInfoForm" validate-first @submit="handleClose(idIndex)">
        <van-field name="appntIdTypeName" label="证件类型" v-model="appntInfo.appntIdTypeName" placeholder="请选择证件类型"
          :is-link="true" :rules="[{ required: true, message: '请选择证件类型' }]" disabled clearable readonly />
        <van-field :error="false" label="证件号码" name="validator" v-model.trim="appntInfo.appntIdNo" clearable
          placeholder="请输入证件号码" @blur="setAppntBirthdayGender" :rules="[
            { required: true, message: '请填写参保证件号' },
            {
              validator: InsuredIdNoValidator(idIndex),
              message: '参保人证号格式不正确'
            },
            {
              validator: noTwoInsuredIdNo(idIndex),
              message: '已存在相同证件号参保人'
            },
            {
              validator: spouseGenderValidator(idIndex),
              message: '配偶，参保人应与购买人性别不同'
            }
          ]" />
        <div class="but_remove" style="margin: 16px;">
          <van-button round block type="info" native-type="button" @click.stop="closePoup">取消</van-button>
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </van-dialog>
    <van-popup v-model="showTypeFlag" round position="bottom">
      <van-picker title="证件类型" show-toolbar :columns="cardTypeColumns" @confirm="confirmCardType"
        @cancel="showTypeFlag = false" />
    </van-popup>
    <van-popup v-model="showBirthdayFlag" position="bottom">
      <van-datetime-picker type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" :formatter="formatterDate"
        @confirm="onConfirmBirthday" @cancel="showBirthdayFlag = false" />
    </van-popup>
  </div>
</template>
<script>
import { FindUserInsuranceDetail, findInsurancePolicyUrl } from '@/api/user'
import { MobileRefund } from '@/api/refund.js'
import { GetInsurancePlanByCode, updatePersonCardNo } from '@/api/insurance'
import {
  PolicyStatus,
  PolicyPayStatus,
  Gender,
  CertifyType,
  Relation
} from '@/util/enum-data'
import {
  Number_Format,
  GET_BIRTHDAY_FROM_ID,
  GET_GENDER_FROM_ID
  // QueryToJSON
  // IsEmptyObject,
  // JsonToParams
} from '@/util/tools'
import OtherType from '@/views/InsuBuyInfo/minix/OtherType'

import { CHECK_ID, CHECK_MOBILE_PHONE } from '@/util/validate'
//
import { checkSpouseGender, checkAgeGap } from '@/util/insuCheck'
// import dayjs from 'dayjs'
// import MainMenu from '@/components/MainMenu'
import { AppCode } from '@/util/auth'

import { Dialog } from 'vant'
import {
  CloseUserInsured,
  getPaymentUrl,
  GetVerificationCode
} from '@/api/user'
import { NewPayTrade } from '@/api/pay'
import { WxConfig } from '@/util/wxShare'
import { mapState } from 'vuex'
import { TurntableLottery } from '@/util/config' // 抽奖
// 保险产品
// import { AreaProductCode } from '@/util/config'
export default {
  name: 'PolicyDetail',
  components: {
    // MainMenu
  },
  filters: {
    filterBirthday(val) {
      if (val) {
        return val.slice(0, 10)
      }
    },
    filterStatus: function (val) {
      return PolicyStatus[val] || ''
    },
    filterPay: function (val) {
      return PolicyPayStatus[val] || ''
    },
    shortDate: function (val) {
      return val ? val.substr(0, 10) : ''
    },
    payFrequency(val) {
      const typeText = {
        Y: '年交',
        M: '月交',
        D: '日交'
      }
      let result = typeText[val.payFrequencyFlag]
      if (
        val.payFrequencyFlag === 'Y' &&
        val.payFrequencyNumber + '' === '1000'
      ) {
        result = '趸交'
      }
      // if (val.payFrequencyFlag === 'Y' && val.payFrequencyNumber + '' === '1') {
      //   result = '趸交'
      // }
      return result
    },
    unitText(val) {
      const typeText = {
        Y: '年',
        M: '月',
        D: '日'
      }
      let result = typeText[val.payFrequencyFlag]
      if (
        val.payFrequencyNumber === '1000' ||
        val.payFrequencyNumber === 1000
      ) {
        result = ''
      }
      return result
    },
    filterNumMilli(val) {
      return val ? Number_Format(val, 2, '.') : ''
    },
    filterGender(val) {
      return Gender[val] || ''
    },
    filterrelation(val) {
      return Relation[val] || ''
    },
    filterCardType(val) {
      return CertifyType[val] || ''
    }
  },
  mixins: [OtherType],
  props: {},

  data() {
    return {
      policyId: '',
      showTypeFlag: false,
      showBirthdayFlag: false,
      minDate: new Date('1900/01/01'),
      maxDate: new Date(),
      // 证件类型集合
      cardTypeColumns: [
        { type: 'identityCard', text: '身份证' },
        { type: 'HongKongMacaoAndTaiwanPass', text: '港澳台同胞证' },
        { type: 'officerCard', text: '军官证' },
        { type: 'passport', text: '护照' }
        // { type: 'otherIdentityCard', text: '外国人永久居住身份证' }
      ],
      sf: '',
      sms: '',
      // vcodeshow: false,
      type: 'insured',
      refundFlag: false,
      policyDetail: {},
      planInfo: {},
      currentRefundInfo: {},
      appntMobileNumber: '',
      captcha: '',
      isDisable: false,
      errMsg: {
        mobilePhone: '',
        captcha: ''
      },
      captchaText: '获取验证码',
      // isShowClaimBtn: false
      show: false,
      idIndex: '',
      appntInfo: {
        appntIdType: '',
        appntIdTypeName: '',
        birthday: '',
        gender: '',
        appntIdNo: ''
      },
      codeList: [
        'yxhb00000006',
        'unionPay00000001',
        'yxhb00000102',
        'yxhb00000115'
      ]
    }
  },

  computed: {
    ...mapState(['userInfo']),
    appntInsuredInfo: function () {
      let obj = {
        appnt: {},
        insured: []
      }
      if (this.policyDetail && this.policyDetail.userInsureEntities) {
        this.policyDetail.userInsureEntities.forEach(function (item) {
          if (item.personnelType === 'policyHolder') {
            obj.appnt = item
            // obj.appnt.birthDay = GET_BIRTHDAY_FROM_ID(item.userCardNo).join('-')
            // obj.appnt.gender = GET_GENDER_FROM_ID(item.userCardNo)
          }
          if (item.personnelType === 'insured') {
            // item.birthDay = GET_BIRTHDAY_FROM_ID(item.userCardNo).join('-')
            // item.gender = GET_GENDER_FROM_ID(item.userCardNo)
            obj.insured.push(item)
            console.log(obj.insured, '2323')
          }
        })
      }
      return obj
    }
  },

  watch: {},

  created() { },

  async mounted() {
    this.policyId = this.$route.params.id
    if (this.userInfo.mobilePhone) {
      this.initPolicyDetail()
    } else {
      this.$router.push({ path: '/user-center' })
    }
  },

  destroyed() { },

  methods: {
    showQuick(v) {
      let list = ['effective', 'unEffective', 'generating']
      let flag =
        v.insuranceProductCode !== 'HN22001' &&
        list.includes(v.insuranceStatus)
      return flag
    },
    async quickInsure(v) {
      this.$router.push({
        path: '/area-insu-buy-detail',
        query: {
          insuranceId: v.insuranceId,
          fromSourceCode: v.fromSourceCode,
          baosicode: 'HN22001',
          isRenewal: '20'
        }
      })
    },
    // 子女应小于购买人18岁以上
    insuredChildrenAgeValidator(i) {
      console.log('子女年龄校验')
      return () => {
        if (!this.appntInfo.appntIdNo) {
          return true
        }
        return (
          this.appntInsuredInfo.insured[i].insuredRelation !== 'children' ||
          this.appntInsuredInfo.appnt.userCardType !== 'identityCard' ||
          this.appntInsuredInfo.insured[i].userCardType !== 'identityCard' ||
          checkAgeGap({
            olderId: this.appntInsuredInfo.appnt.userCardNo,
            youngerId: this.appntInfo.appntIdNo,
            gap: 18
          })
        )
      }
    },
    // 父母应大于购买人18岁以上
    insuredParentAgeValidator(i) {
      // console.log('父母年龄校验', this.appntInsuredInfo.insured[i].insuredRelation, this.appntInsuredInfo.appnt.userCardType, this.appntInsuredInfo.insured[i].userCardType, this.appntInfo.appntIdNo, this.appntInsuredInfo.appnt.userCardNo)
      return () => {
        if (!this.appntInfo.appntIdNo) {
          return true
        }
        return (
          this.appntInsuredInfo.insured[i].insuredRelation !== 'parent' ||
          this.appntInsuredInfo.appnt.userCardType !== 'identityCard' ||
          this.appntInsuredInfo.insured[i].userCardType !== 'identityCard' ||
          checkAgeGap({
            olderId: this.appntInfo.appntIdNo,
            youngerId: this.appntInsuredInfo.appnt.userCardNo,
            gap: 18
          })
        )
      }
    },
    // 判断购买人是否购买过保单（带添加）
    // 设置购买人年龄、性别👌
    setAppntBirthdayGender() {
      const birthArr = GET_BIRTHDAY_FROM_ID(this.appntInfo.appntIdNo)
      console.log(birthArr, '1111111111111111')
      if (this.appntInfo.appntIdType === 'identityCard') {
        this.appntInfo.birthday = birthArr.join('-')
        this.appntInfo.gender = GET_GENDER_FROM_ID(this.appntInfo.appntIdNo)
      }
    },
    // 关系为配偶，投参保人关系不能一致
    spouseGenderValidator(i) {
      return () => {
        if (!this.appntInsuredInfo.appnt.userCardNo) {
          return true
        }
        const bo = checkSpouseGender({
          appntId: this.appntInsuredInfo.appnt.userCardNo,
          insuredId: this.appntInfo.appntIdNo
        })
        console.log(
          '证件号校验',
          this.appntInsuredInfo.insured[i].insuredRelation,
          this.appntInfo.appntIdTypeName
        )
        return (
          this.appntInsuredInfo.insured[i].insuredRelation !== 'spouse' ||
          this.appntInfo.appntIdTypeName !== '身份证' ||
          this.appntInfo.appntIdTypeName !== 'identityCard' ||
          bo
        )
      }
    },
    // 校验参保人证件号格式👌
    InsuredIdNoValidator(i) {
      return () => {
        if (
          this.appntInsuredInfo.insured[i].userCardType === 'identityCard'
        ) {
          return CHECK_ID(this.appntInfo.appntIdNo)
        } else {
          console.log('wei走分支')
          return true
        }
      }
    },
    // 已存在相同证件号参保人
    noTwoInsuredIdNo(i) {
      return () => {
        let bo = true
        // 判断是否存在两个相同的参保人身份证号
        this.appntInsuredInfo.insured.forEach((item, idx) => {
          if (
            idx < i &&
            item.userCardNo &&
            item.userCardNo === this.appntInfo.appntIdNo
          ) {
            bo = false
          }
        })
        return bo
      }
    },
    closePoup() {
      this.show = false
      this.$set(this.appntInfo, 'appntIdType', '')
      this.$set(this.appntInfo, 'appntIdTypeName', '')
      this.$set(this.appntInfo, 'birthday', '')
      this.$set(this.appntInfo, 'gender', '')
      this.$set(this.appntInfo, 'appntIdNo', '')
      console.log('关闭时重置')
    },
    async handleClose(i) {
      try {
        console.log(this.appntInfo)
        await updatePersonCardNo({
          personId: this.appntInsuredInfo.insured[i].userInsurePersonId,
          userSex: this.appntInfo.gender,
          userBirthday: this.appntInfo.birthday,
          userCardNo: this.appntInfo.appntIdNo
        })
        this.initPolicyDetail()
        this.show = false
        this.$set(this.appntInfo, 'appntIdType', '')
        this.$set(this.appntInfo, 'appntIdTypeName', '')
        this.$set(this.appntInfo, 'birthday', '')
        this.$set(this.appntInfo, 'gender', '')
        this.$set(this.appntInfo, 'appntIdNo', '')
        console.log('关闭时重置')
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      }
    },

    // 补全证件号
    goChange(i) {
      this.appntInfo.appntIdType = this.appntInsuredInfo.insured[
        i
      ].userCardType
      this.appntInfo.appntIdTypeName =
        CertifyType[this.appntInsuredInfo.insured[i].userCardType] || ''
      // <td class="td-text">{{ v.userCardType | filterCardType }}</td>
      this.show = true
      this.idIndex = i
    },
    // ckpicturecaptcha(){
    //   const d = new Date().getTime()
    //   this.sf = `${process.env.VUE_APP_API_PATH}/services/web/memberResource/getImageVerifyCode?busId=${this.appntMobileNumber}&id=${d}`
    // },
    async confirmsf() {
      try {
        // beforeCaptcha: this.sms
        await GetVerificationCode({ mobilePhone: this.appntMobileNumber })
        this.captchaText = '获取中...'
        this.isDisable = true
        let countDown = 60
        this.captchaText = `重新获取(${countDown})`
        this.veriInterval = setInterval(() => {
          countDown = countDown - 1
          if (countDown === 0) {
            clearInterval(this.veriInterval)
            this.isDisable = false
            this.captchaText = `获取验证码`
          } else {
            this.captchaText = `重新获取(${countDown})`
          }
        }, 1000)
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      }
    },
    closesf() {
      this.isDisable = false
    },
    async initPolicyDetail() {
      try {
        this.policyDetail = await FindUserInsuranceDetail({
          id: this.policyId,
          appCodeId: AppCode
        })
        console.log('this.policyDetail', this.policyDetail)
        // 微信支付 配置
        await WxConfig()
        // 判断是否有支付的处理
        this.isNeedPay()

        // 是否特药
        this.checkIsLeChengTeYao()

        // 获取保险产品详情
        this.planInfo = await GetInsurancePlanByCode({
          productCode: this.policyDetail.insuranceProductCode
        })
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      }
    },
    // 取消订单
    closeUserInsured() {
      this.$dialog
        .confirm({
          title: '是否关闭订单'
        })
        .then(async () => {
          const toast = this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '加载中...'
          })
          try {
            await CloseUserInsured({
              insuranceId: this.$route.params.id || ''
            })
            this.$toast.success({
              message: '订单已取消',
              onClose: () => {
                this.initPolicyDetail()
              }
            })
          } catch (e) {
            this.$notify({ type: 'danger', message: e.message })
          }
          toast.clear()
        })
        .catch(() => { })
    },
    switchType(type) {
      this.type = type
    },
    async goPay() {
      switch (this.policyDetail.fromSourceCode) {
        case 'yxhb00000006':
        case 'yxhb00000115':
          this.$toast({
            message: '该笔为翼支付订单，无法在微信内支付，可以先取消该笔订单'
          })
          break
        case 'unionPay00000001':
        case 'yxhb00000102':
          this.$toast({
            message: '该笔为云闪付订单，无法在微信内支付，可以先取消该笔订单'
          })
          break
        case 'yxhb00000002':
          this.$toast({
            message: '该笔为支付宝订单，无法在微信内支付，可以先取消该笔订单'
          })
          break
        default:
          this.goPayType()
          break
      }
    },
    async goPayType() {
      let openid = ''
      let res = ''
      if (this.$isMini) {
        switch (this.policyDetail.fromSourceCode) {
          case 'yxhb00000304':
            openid = sessionStorage.getItem('thridOpenId')
            res = await this.getPaymentUrl(openid)
            window.wx.miniProgram.navigateTo({
              url: `/pages/payPage/payPage?data=${encodeURIComponent(res)}`
            })
            break
          case 'yxhb00000362':
            openid = sessionStorage.getItem('thridOpenId')
            res = await this.getPaymentUrl(openid)
            window.wx.miniProgram.navigateTo({
              url: `/pages/third-pay/payPage?data=${encodeURIComponent(res)}`
            })
            break
          default:
            openid = this.$store.state.userInfo.openId
            res = await this.getPaymentUrl(openid)
            window.location.href = res
            break
        }
      } else {
        openid = this.$store.state.userInfo.openId
        res = await this.getPaymentUrl(openid)
        window.location.href = res
      }
    },
    async getPaymentUrl(openId) {
      try {
        let res = await getPaymentUrl({
          orderSn: this.policyDetail.payOrder.orderSn,
          openId: openId,
          payType: 'weichatAcc',
          clientPayType: 'JSAPI'
        })
        return res.paymentUrl
      } catch (error) {
        this.$toast(error.message)
      }
    },
    checkPhone() {
      if (!this.appntMobileNumber) {
        this.errMsg.mobilePhone = '请填写手机号码！'
        return false
      } else if (!CHECK_MOBILE_PHONE(this.appntMobileNumber)) {
        this.errMsg.mobilePhone = '手机号格式不正确！'
        return false
      } else {
        this.errMsg.mobilePhone = ''
        return true
      }
    },
    checkVeriCode() {
      if (!this.captcha) {
        this.errMsg.captcha = '验证码必填！'
        return false
      }
      this.errMsg.captcha = ''
      return true
    },
    async sendVeriCode() {
      if (!this.appntMobileNumber) {
        this.$notify({ type: 'danger', message: '请填写手机号' })
        return
      }
      if (!CHECK_MOBILE_PHONE(this.appntMobileNumber)) {
        this.$notify({ type: 'danger', message: '手机号格式不正确' })
        return
      }
      if (this.isDisable) {
        return
      }
      this.confirmsf()
      // const d = new Date().getTime()
      // this.sf = `${process.env.VUE_APP_API_PATH}/services/web/memberResource/getImageVerifyCode?busId=${this.appntMobileNumber}&id=${d}`
      // this.vcodeshow = true
    },
    // 退款
    refundBtn(val) {
      switch (this.policyDetail.payType) {
        case 'selfAcc':
          switch (this.policyDetail.insuranceStatus) {
            case 'effective':
            case 'partEffective':
              this.$router.push({
                path: '/surrender-verification',
                query: {
                  insuranceId: this.policyDetail.insuranceId,
                  userInsurePersonId: val.userInsurePersonId
                }
              })
              break
            default:
              this.$dialog
                .alert({
                  message:
                    '确认要退单吗？退单您将会失去保额300万的湖南爱民保补充医疗保障',
                  showCancelButton: true,
                  confirmButtonText: '继续退单',
                  cancelButtonText: '手滑点错'
                })
                .then(() => {
                  this.currentRefundInfo = {}
                  this.refundFlag = true
                  this.currentRefundInfo = val
                })
              break
          }
          break
        default:
          switch (val.insuranceStatus) {
            case 'effective':
              this.$router.push({
                path: '/surrender-verification',
                query: {
                  insuranceId: this.policyDetail.insuranceId,
                  userInsurePersonId: val.userInsurePersonId
                }
              })
              break
            case 'examine_pass':
              this.$dialog
                .alert({
                  message:
                    '确认要退单吗？退单您将会失去保额300万的湖南爱民保补充医疗保障',
                  showCancelButton: true,
                  confirmButtonText: '继续退单',
                  cancelButtonText: '手滑点错'
                })
                .then(() => {
                  this.currentRefundInfo = {}
                  this.refundFlag = true
                  this.currentRefundInfo = val
                })
              break
            default:
              Dialog.alert({
                message: '保单已承保，电子保单生成中<br/>暂不支持退保',
                theme: 'round-button',
                messageAlign: 'center'
              })
              break
          }
          break
      }
    },
    async OrderRefund() {
      if (!this.appntMobileNumber) {
        this.$dialog
          .alert({
            title: '提示',
            message: '手机号不能为空',
            theme: 'round-button'
          })
          .then(() => {
            // on close
          })

        return false
      }
      if (!this.captcha) {
        this.$dialog
          .alert({
            title: '提示',
            message: '验证码不能为空',
            theme: 'round-button'
          })
          .then(() => {
            // on close
          })
        return false
      }
      const loading = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '退款中...'
      })
      console.log(this.currentRefundInfo, '8888888888888')
      console.log(process.env.VUE_APP_BUILD_TARGET, '8888888888888')

      const obj = {
        // amount: this.currentRefundInfo.insuredFeeAmount,
        amount: process.env.VUE_APP_BUILD_TARGET === 'prod' ? 29 : 0.01,
        refundPersonId: this.currentRefundInfo.userInsurePersonId,
        insuranceId: this.policyDetail.insuranceId,
        appntMobileNumber: this.appntMobileNumber,
        captcha: this.captcha
      }
      try {
        const res = await MobileRefund(obj)
        console.log('退款结果', res)
        this.$toast('退款成功')
        this.refundFlag = false
        this.initPolicyDetail()
      } catch (e) {
        this.$notify({ type: 'danger', message: e.message })
      } finally {
        loading.clear()
      }
    },
    // 获取个人保单pdf
    getPersonPolicyPdf(val) {
      const data = {
        insuranceId: this.policyDetail.insuranceId,
        userInsurePersonId: val.userInsurePersonId
      }
      findInsurancePolicyUrl(data, {
        isShow: true,
        text: '获取中...'
      }).then(res => {
        location.href = res
      })
    },
    // 是否有支付处理需要
    isNeedPay() {
      if (
        this.policyDetail.payStatus === 'waitPay' &&
        this.policyDetail.insuranceStatus === 'examine_pass'
      ) {
        this.policyDetail.isNeedPay = true
      }
    },
    // 检查是否冀惠保
    checkIsLeChengTeYao() {
      const leChengTeYaoProd =
        // this.policyDetail.insuranceProductCode === AreaProductCode
        (this.policyDetail = Object.assign({}, this.policyDetail, {
          leChengTeYaoProd
        }))
    },
    // 微信环境下支付
    async handleWxchatPay(orderInfo) {
      const res = await NewPayTrade({
        orderSn: orderInfo.orderSn,
        payType: 'weichatAcc',
        openId: this.$store.state.userInfo.openId,
        clientPayType: 'JSAPI'
      })
      const _this = this
      window.wx.chooseWXPay({
        timestamp: res.weixinAppPay.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: res.weixinAppPay.nonceStr, // 支付签名随机串，不长于 32 位
        package: res.weixinAppPay.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: res.weixinAppPay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: res.weixinAppPay.paySign, // 支付签名
        success: function () {
          _this.initPolicyDetail()
        }
      })
    },
    onClickluckdraw() {
      location.href = TurntableLottery //抽奖
    }
  }
}
</script>

<style scoped lang="scss">
.basic-info {
  padding: px2rem(10, 375) px2rem(10, 375);
  color: #4c4c4c;
  background-color: #fff;

  .basic-title {
    font-size: px2rem(16, 375);
    line-height: 1.5;
    margin-bottom: px2rem(10, 375);
    display: flex;
    align-items: center;
  }

  .status {
    min-width: 4rem;
    flex-shrink: 0;
    text-align: center;
    padding: 0 px2rem(5, 375);
    margin-left: px2rem(10, 375);
    border: 1px solid $themeColor;
    border-radius: px2rem(4, 375);
    color: $themeColor;
    font-size: px2rem(14, 375);
  }

  .basic-text {
    margin-bottom: px2rem(5, 375);
    font-size: px2rem(14, 375);
    line-height: 1.5;
  }

  .basic_content {
    display: flex;
    justify-content: space-between;

    .basic_content_right {
      width: xvw(200);
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      background: linear-gradient(to right, #db0003, #ff6c61);
      background-size: contain;
      background-position-x: center;
      border-radius: px2rem(18, 375);
      height: px2rem(30, 375);
    }
  }
}

.type-menu {
  display: flex;
  align-items: center;
  padding: px2rem(10, 375) 0 0 0;
  margin: px2rem(10, 375) 0;
  background-color: #fff;

  .type-item {
    flex-basis: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    >div {
      position: relative;
      padding-bottom: 0.8rem;
      /*width: px2rem(64, 375);*/
      text-align: center;
      font-size: px2rem(16, 375);
      line-height: px2rem(22, 375);
      color: #4c4c4c;
    }

    .arc-img {
      position: absolute;
      left: 0;
      bottom: 0;
      display: none;
      width: 100%;
    }
  }

  .type-item.active {
    >div {
      color: #e7201e;
    }

    .arc-img {
      display: inline;
    }
  }
}

.policy-info {
  width: 100%;
  background-color: #fff;

  .table-title {
    font-size: px2rem(14, 375);
    line-height: px2rem(24, 375);
  }

  .table-wrap {
    width: px2percent(320, 375);
    margin: 0 auto;
    border-bottom: 1px solid #f5f5f7;
  }

  table {
    width: 100%;
    // padding-bottom: px2rem(10, 375);

    td {
      font-size: px2rem(14, 375);
      line-height: px2rem(24, 375);
    }

    .td-tag {
      width: 40%;
      color: #999999;
    }

    .td-text {
      color: #4c4c4c;
    }
  }
}

.btns {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.btn-group {
  display: flex;

  div {
    color: #fff;
    text-align: center;
    font-size: px2rem(16, 375);
    line-height: 2.5;
    background: linear-gradient(45deg, #ff6c61, #db0003);
    border-radius: px2rem(25, 375);
  }
}

.btn-div {
  flex-basis: 49.5%;
  flex-grow: 1;
  margin: 1rem;
  color: #fff;
  text-align: center;
  font-size: px2rem(16, 375);
  line-height: 2.5;
  background: linear-gradient(to right, #db0003 0%, #ff6c61 100%);
  border-radius: px2rem(25, 375);
}

.refund-comtent {
  width: 90%;
  max-width: 750px;
  padding: px2rem(40, 750) px2rem(20, 750);
  background-color: #fff;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: px2rem(20, 750);
}

.refund-title {
  margin-bottom: px2rem(20, 750);
  font-size: px2rem(36, 750);
  text-align: center;
}

.code-btn {
  margin-left: px2rem(25, 750);
  background: linear-gradient(to bottom, #ff8876 0%, #ff5041 100%);
  outline: none;
  border: none;
}

.disable-btn {
  background: #aaa;
  color: #fff;
  border: 1px solid transparent;
}

.refund-btn-group {
  padding-top: px2rem(20, 750);
  display: flex;
  justify-content: space-between;

  .submit-btn {
    width: 40%;
    border: none;
    outline: none;
    color: #fff;
    font-size: px2rem(16, 375);
    background: linear-gradient(to right, #db0003, #ff6c61);
  }

  .cancel-btn {
    width: 40%;
    font-size: px2rem(16, 375);
  }
}

.div-btn {
  width: 90%;
  margin: px2rem(20, 375) auto px2rem(20, 375);
  text-align: center;
  // background: url('../../assets/img/gift_insu/buy-insu.png') center/100%
  //   100% no-repeat;
  border-radius: px2rem(78);
  // background-color: #fbdf8d;
  font-size: px2rem(21, 375);
  line-height: px2rem(55, 375);
  letter-spacing: px2rem(3, 375);
}

.btn_success {
  border: solid 1px #fe5543;
  color: #ff5443;
}

.but_remove {
  display: flex;

  .van-button {
    height: 36px;
    margin: 10px;
    background: linear-gradient(to right, #db0003 0%, #ff6c61 100%);
    border: none;
  }
}
</style>
